module.exports = __webpack_public_path__ + "media/images/logos/forbes-a0dddaafb0af99b74ac2e27f095cc846.svg";